import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import BrandLogosStrip from '@/pages/home/components/BrandLogosStrip';
import PerformanceHero from './components/PerformanceHero';
import StatsStrip from './components/StatsStrip';
import PainPoints from './components/PainPoints';
import TheDifference from './components/TheDifference';
import PracticeAreas from './components/PracticeAreas';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';

export default function PerformancePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PerformanceHero />
      <BrandLogosStrip />
      <StatsStrip />
      <PainPoints />
      <TheDifference />
      <PracticeAreas />
      <HowItWorks />
      <Testimonials />
      <FinalCTA />
      <Footer />
    </div>
  );
}
